import React from "react";
import NFLookupEmptyForms from "../../../Shared/NewForms/NFLookupEmptyForms";

const SetItemPricesGenericSkeleton = () => {
  return (
    <>
      <NFLookupEmptyForms />
    </>
  );
};

export default SetItemPricesGenericSkeleton;
